import { useEffect } from 'react';
import { useAuthStore } from './useAuthStore';

// Custom hook to use user status
export const useAuthStatus = () => {
  const { token, loginState, checkLogin, initialize, setToken } = useAuthStore(
    (state) => ({
      token: state.token,
      loginState: state.loginState,
      checkLogin: state.checkLogin,
      initialize: state.initialize,
      setToken: state.setToken,
    })
  );

  useEffect(() => {
    initialize(); // Initialize the store when the component mounts
  }, [initialize]);

  const isLogin = () => {
    checkLogin();
    return loginState;
  };

  return { token, isLogin, loginState, setToken };
};
